<template>
        <mdb-navbar class="flexible-navbar main-navbar main-app-navbar" :toggler="false"  position="top"> 
            <mdb-navbar-brand href="/" class="app-brand">
            <router-link to="/" class="text-dark"><strong>TL</strong> | FURNISHWEB</router-link>
            </mdb-navbar-brand>
            <mdb-navbar-nav class="right-nav" right :toggler="false">

            <!--  <form class="d-flex align-items-center">
                <mdb-input type="text" class="text-white bg-light" placeholder="Search" aria-label="Search" label navInput waves waves-fixed />
            </form> -->

            <mdb-nav-item href="#" class="cart-nav" anchorClass="" @click="openFilter" title="Cart">
               <span class="btn-container"><filter-menu/></span>
            </mdb-nav-item>
            <mdb-nav-item href="#" class="cart-nav" anchorClass="" @click="openScan" title="Cart">
               <span class="btn-container"><qrcode-scan/></span>
            </mdb-nav-item>
            <mdb-nav-item href="#" class="cart-nav cart-nav-cart" anchorClass="" @click="openCart" title="Cart">
                <span class="btn-container ">
                <template v-if="cart.length > 0">
                <div color="success" class="cart-count">{{cart.length}}</div>
                </template>
                <cart-icon/>
                </span>
            </mdb-nav-item>
            <mdb-nav-item href="#" class="cart-nav" anchorClass="" @click="fnLogout" title="Logout">
                <span class="btn-container"><arrow-right/></span>
            </mdb-nav-item>
            </mdb-navbar-nav>
        </mdb-navbar>
</template>


<script>
import {mdbInput,mdbContainer, mdbNavbar, mdbTooltip,mdbNavbarBrand, mdbNavItem, mdbNavbarNav, mdbNavbarToggler, mdbBreadcrumb, mdbDropdown, mdbDropdownToggle, mdbDropdownMenu, mdbDropdownItem, mdbIcon, mdbBadge } from 'mdbvue'
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'Navbar',
  props: {
    page: {
      type: String
    }
  },
  components: {
    mdbInput,mdbContainer,
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBreadcrumb,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbTooltip,
    mdbIcon,
    mdbBadge
  },
  data () {
    return {
      activePage: this.page,
      toggle: false
    }
  },
  methods: {
    ...mapActions('AuthModule',[
      'Logout'
    ]),

    fnLogout(){
      this.Logout()
    },

    openCart(){
      this.$eventBus.$emit('open-cart')
    },

    openFilter(){
        this.$eventBus.$emit('open-filter')
    },
    openScan(){
      this.$eventBus.$emit('open-scan')  
    },
  },
  computed: {
    computedPage () {
      return {
        activePage: this.page
      }
    },
    ...mapGetters('CartModule',[
            'cart',
        ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navbar .nav-item {
  line-height: 24px;
  font-size: 16px;
}
.navbar .dropdown-toggle {
  padding: 0 10px;
  font-size: 16px;
}

.navbar ul {
  padding: 5px 0;
}

.navbar .btn {
  font-weight: 300;
}

.navbar-collapse {
  order: 0 !important;
}

.navbar .notifications-nav .dropdown-menu {
  width: 23rem; }

.navbar-expand-lg .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.btn-transparent {
  background-color: transparent !important;
  color: #000;
  text-transform: none;
  box-shadow: none !important;
}

.btn-transparent:hover, .btn-transparent:active {
  box-shadow: none !important;
}

.main-navbar{
  padding : 0!important
}

.main-navbar ul{
  padding: 0!important;
}

.user-avatar-icon{
  padding: .5rem 1rem!important
}

.cart-nav.has-cart{
  width : 55px;
}

.my-account-nav{
  padding : 9px 10px
}

.btn-container{
    background : #000;
    color : #fff;padding : 15px;border-radius: 5px;
}

.navbar .nav-item{
    line-height : 42px!important;
}

.cart-nav-cart{
    min-width : 70px;
}
.cart-count{
    position: absolute;
    right: 9px;
    top: 0;
    background: #00c851;
    padding: 9px;
    line-height: 6px;
    border-radius: 15px;
    font-size: 12px;;
}
</style>
